import { lazy, Suspense, useEffect } from "react";
import { BrowserRouter, Navigate, Outlet, Route, Routes, useLocation } from "react-router-dom";
import KioskShell from "@/kiosk/KioskShell";
import KioskHome from "@/kiosk/KioskHome";
import ModelDetail from "@/kiosk/ModelDetail";
import Compare from "@/kiosk/Compare";
import LeadForm from "@/kiosk/LeadForm";
import TakeHome from "@/kiosk/TakeHome";
import Quiz from "@/kiosk/Quiz";
import Exchange from "@/kiosk/Exchange";
import ClerkAuthProvider from "@/components/auth/ClerkAuthProvider";

const AdminLayout = lazy(() => import("@/admin/AdminLayout"));
const Overview = lazy(() => import("@/admin/Overview"));
const Content = lazy(() => import("@/admin/Content"));
const Approvals = lazy(() => import("@/admin/Approvals"));
const Leads = lazy(() => import("@/admin/Leads"));
const Audit = lazy(() => import("@/admin/Audit"));
const Devices = lazy(() => import("@/admin/Devices"));
const Users = lazy(() => import("@/admin/Users"));
const Settings = lazy(() => import("@/admin/Settings"));
const Calendar = lazy(() => import("@/admin/Calendar"));
const Insights = lazy(() => import("@/admin/Insights"));
const SignInPage = lazy(() => import("@/admin/AuthPages").then((m) => ({ default: m.SignInPage })));
const SignUpPage = lazy(() => import("@/admin/AuthPages").then((m) => ({ default: m.SignUpPage })));

const ClerkShell = () => (
  <ClerkAuthProvider>
    <Suspense fallback={null}><Outlet /></Suspense>
  </ClerkAuthProvider>
);

const ViewportFit = () => {
  const { pathname } = useLocation();
  useEffect(() => { window.__paneloFit?.(); }, [pathname]);
  return null;
};

export default function App() {
  return (
    <BrowserRouter>
      <ViewportFit />
      <Routes>
        <Route path="/" element={<Navigate to="/kiosk" replace />} />
        <Route path="/kiosk" element={<KioskShell />}>
          <Route index element={<KioskHome />} />
          <Route path="model/:slug" element={<ModelDetail />} />
          <Route path="compare" element={<Compare />} />
          <Route path="book/:type" element={<LeadForm />} />
          <Route path="quiz" element={<Quiz />} />
          <Route path="exchange" element={<Exchange />} />
        </Route>
        <Route path="/m/:slug" element={<TakeHome />} />
        <Route element={<ClerkShell />}>
          <Route path="/sign-in/*" element={<SignInPage />} />
          <Route path="/sign-up/*" element={<SignUpPage />} />
          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<Overview />} />
            <Route path="content" element={<Content />} />
            <Route path="approvals" element={<Approvals />} />
            <Route path="leads" element={<Leads />} />
            <Route path="audit" element={<Audit />} />
            <Route path="devices" element={<Devices />} />
            <Route path="users" element={<Users />} />
            <Route path="settings" element={<Settings />} />
            <Route path="calendar" element={<Calendar />} />
            <Route path="insights" element={<Insights />} />
          </Route>
        </Route>
        <Route path="*" element={<Navigate to="/kiosk" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
